/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// 1. React & Hooks
import React, { useState, useEffect, useRef } from 'react';
// 2. External libraries
import axios from 'axios';
import dayjs from 'dayjs';
import DatePicker, { registerLocale } from 'react-datepicker';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import notify, { MESSAGES } from '../../utils/notify';
import { confirmAction } from '../../utils/confirm';
import {
  normalizeProcurementDetail,
  FORM_INITIAL_STATE,
  denormalizeProcurementDetail,
  displayValue,
  formatSubmittedDate,
  getProcurementStage,
  isStepCompleted,
  PROCUREMENT_STEPS,
  PROCUREMENT_WORK_STEPS,
  PROCUREMENT_TYPE_LABELS,
  toClauseItem,
} from './utils/procurementHelpers';
import { focusFieldById, requirementFieldId } from './utils/focusField';
import { compositionRangeErrors, productTypeNames } from './utils/productTypes';
import './ProcurementView.css';
import { formatDateTimeWithTimezone } from '../../utils/dateformatter';
import logger from '../../utils/logger';

// 3. CSS imports
import 'react-quill/dist/quill.snow.css';

import { Col, Container, Row, TabContent, TabPane } from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';

// 5. Router
import { useParams, useNavigate, data } from 'react-router-dom';

// 6. Data, konstanta, utils
import { incoTermTable, deliveryUnit } from '../../common/data';
import { orderSummary } from '../../common/data/ecommerce';
import { isNumericOnly } from '../../utils/validators';
import Swal from 'sweetalert2';

// 7. Local components
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ActionMenu from './ActionMenu';
import DmutInvitationTab from './DmutInvitationTab';
import GtcTab from './GtcTab';
import OverviewTab from './OverviewTab';
import ProcurementHero from './component/ProcurementHero';
import ProcurementStepper from './component/ProcurementStepper';
import './component/procurementDetail.css';
import RequirementTab from './RequirementTab';
import SupportDocumentTab from './SupportDocumentTab';

// 8. Config & auth
import { api, web } from '../../config';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';

// 9. Locale
import id from 'date-fns/locale/id';

// 10. Register locale & axios config
registerLocale('id', id);

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const ProcurementForm = () => {
  const navigate = useNavigate();
  const token = getAuthToken();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountry, setselectedCountry] = useState(null);
  const [selectedState, setselectedState] = useState(null);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [value, setValue] = useState('0');
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [ids] = useState(useParams().id);
  const [completedMode, setCompletedMode] = useState(false);
  const [dataCause, setDataCause] = useState({
    items: [],
  });

  const procurementTypeMap = {
    PelelanganKhusus: 'Pelelangan Khusus',
    PemilihanLangsung: 'Pemilihan Langsung',
    TunjukLangsung: 'Tunjuk Langsung',
  };

  const LoadDefault = () => {
    fetchDataProcurement(ids, setForm, token);
  };

  const [form, setForm] = useState(FORM_INITIAL_STATE);

  const fetchDataProcurement = async (ids, setForm, token) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      let apiResponse = response.data ?? response;
      const data =
        typeof apiResponse.data === 'object' && apiResponse.data !== null
          ? apiResponse.data
          : apiResponse;

      setForm(normalizeProcurementDetail(data));

      const quantityItems = (data.procurementClauseDetails || []).map(
        toClauseItem
      );
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.warn('Error fetching data from  API:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const silentRefresh = async () => {
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      let apiResponse = response.data ?? response;
      const data =
        typeof apiResponse.data === 'object' && apiResponse.data !== null
          ? apiResponse.data
          : apiResponse;

      const normalized = normalizeProcurementDetail(data);
      const filtered = Object.fromEntries(
        Object.entries(normalized).filter(([, v]) => v != null)
      );
      setForm(prev => ({ ...prev, ...filtered }));

      const quantityItems = (data.procurementClauseDetails || []).map(
        toClauseItem
      );
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.warn('Silent refresh error:', error);
    }
  };

  const selectedFields = denormalizeProcurementDetail(form, dataCause);

  useEffect(() => {
    if (ids) {
      LoadDefault(ids, setForm, token);
    }
  }, [ids, token]);

  useEffect(() => {
    if (!ids || !token) return;

    autoSaveIntervalRef.current = setInterval(
      () => {
        if (form.isProcurementCompleted === false) {
          //handleAuthSaveProc();
          // toast.info('Data Automatically Updated', {
          //   position: 'top-right',
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: false,
          // });
        }
      },
      2 * 60 * 1000
    );

    return () => {
      if (autoSaveIntervalRef.current) {
        clearInterval(autoSaveIntervalRef.current);
      }
    };
  }, [ids, token, form.isProcurementCompleted]);

  const handleSaveCompleteData = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextProcurement/${ids}`,
        null,
        {
          headers: {
            Accept: '*/*',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const handleSaveCompleteDocProc = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextSupportingDocuments/${ids}`,
        null,
        {
          headers: {
            Accept: '*/*',
            authentication: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const dmutpayload = {
    justifikasi: null,
    procurementMitraFromDmut: form.procurementMitra,
  };

  const handleSaveCompleteDmutProc = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextDMUTInvitation/${ids}`,
        dmutpayload,
        {
          headers: {
            // Accept: '*/*',
            'Content-Type': 'application/json',
            authentication: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const handleSaveDraftProc = () => {
    if (validatedeliveryModal()) {
      return handleSaveProc();
    }
  };

  const autoSaveIntervalRef = useRef(null);

  // The handlers below return their promise so ActionButton can show a loading
  // state and ignore repeat clicks until every request has settled.
  const askCompleteStep = (step, subject) =>
    confirmAction({
      tone: 'primary',
      title: `Complete ${step}?`,
      message:
        'This step will be marked as completed and the procurement moves on to the next step. Check the data first; it may no longer be editable afterwards.',
      subject,
      confirmLabel: `Complete ${step}`,
      cancelLabel: 'Review again',
    });

  const handleSaveCompleteProc = async () => {
    if (!validatecompleteProc()) return;
    if (!(await askCompleteStep('procurement data', form.procurementNumber)))
      return;
    return Promise.all([handleSaveCompleteData(ids), handleSaveProc()]);
  };

  const handleSaveCompleteDoc = async () => {
    if (
      !(await askCompleteStep('supporting documents', form.procurementNumber))
    )
      return;
    return Promise.all([handleSaveCompleteDocProc(ids), handleSaveProc()]);
  };

  // Save first so the selected gtcIds reach the server, then mark the step.
  const handleSaveCompleteGtc = async () => {
    if (!(await askCompleteStep('GTC', form.procurementNumber))) return;
    if (!(await handleSaveProc())) return;
    try {
      await axios.post(`${api.API_URL}/procurement/SaveNextGtc/${ids}`, null, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return true;
    } catch (error) {
      notify.apiError(error, 'complete the GTC step');
    } finally {
      LoadDefault();
    }
  };

  const handleSaveCompleteDmut = async () => {
    if (!(await askCompleteStep('DMUT invitation', form.procurementNumber)))
      return;
    return Promise.all([handleSaveCompleteDmutProc(ids), handleSaveProc()]);
  };

  // Resolves true when saved. A rejected GTC (not Publish/Active) comes back
  // as a 400 whose message is shown as-is.
  const handleSaveProc = async e => {
    try {
      const formData = new FormData();
      formData.append('data', JSON.stringify(selectedFields));
      // formData.append('documentNotaDinas', file); // opsional
      await axios.put(`${api.API_URL}/procurement/${ids}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      notify.success(MESSAGES.saved);
      return true;
    } catch (error) {
      setError(error.message);
      notify.apiError(error, 'save the procurement');
      return false;
    } finally {
      LoadDefault();
    }
  };

  const handleAuthSaveProc = async e => {
    try {
      const formData = new FormData();
      formData.append('data', JSON.stringify(selectedFields));
      const response = await axios.put(
        `${api.API_URL}/procurement/${ids}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      silentRefresh();
    }
  };

  const toggleTab = tab => {
    if (activeTab === tab) return;
    setactiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // The HPS Request step is not part of this flow; HpsRequestTab.js is kept
  // on disk but no longer rendered. Tab 4 is now the GTC step.
  const TAB_COMPONENTS = {
    1: RequirementTab,
    2: SupportDocumentTab,
    3: DmutInvitationTab,
    4: GtcTab,
    5: OverviewTab,
  };

  const stage = getProcurementStage(form);
  const isSubmitted = stage.key === 'submitted';
  const workSteps = PROCUREMENT_WORK_STEPS;
  const firstOpenStep = workSteps.find(step => !isStepCompleted(form, step));
  const stepperSteps = PROCUREMENT_STEPS.map(step => {
    const isReview = step.tab === 5;
    return {
      ...step,
      done: isReview ? isSubmitted : isStepCompleted(form, step),
      locked: isReview && !isSubmitted && Boolean(firstOpenStep),
      lockedHint: `Unlocks after steps 1–${workSteps.length}`,
    };
  });
  const doneCount = stepperSteps.filter(step => step.done).length;

  // Open the first step that still needs work, once, when the data arrives.
  const initialTabSet = useRef(false);
  useEffect(() => {
    if (initialTabSet.current || !form.id) return;
    initialTabSet.current = true;
    setactiveTab(firstOpenStep ? firstOpenStep.tab : 5);
  }, [form.id]);

  const validatedeliveryModal = () => {
    let tempErrors = {};

    if (!form.contractType) {
      tempErrors.contractType = 'Please select Contract Type';
    }

    if (!form.productTypeId) {
      tempErrors.productTypeId = 'Please select Product Type';
    }

    if (!form.productNameId) {
      tempErrors.productNameId = 'Please select Product Name';
    }

    if (!form.contractPeriodTermStart) {
      tempErrors.contractPeriodTermStart = 'Please Enter Start Date';
    }

    if (!form.contractPeriodTermEnd && parseInt(form.contractType, 10) === 1) {
      tempErrors.contractPeriodTermEnd = 'Please Enter End Date';
    }

    Object.assign(tempErrors, compositionRangeErrors(form));

    if (Object.keys(tempErrors).length !== 0) {
      //toast.warning("Please Check Mandatory Fields..");
      notify.warning(MESSAGES.mandatory);
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validatecompleteProc = () => {
    const tempErrors = {};

    // const requiredFields = [
    //   { field: 'contractType', message: 'Please Select Contract Type' },
    //   { field: 'productTypeId', message: 'Please Select' },
    //   { field: 'productNameId', message: 'Please Select' },
    //   {
    //     field: 'productSpecification',
    //     message: 'Please Describe for Product Specification',
    //   },
    //   {
    //     field: 'contractPeriodTermStart',
    //     message: 'Please Enter Period Term Start',
    //   },
    //   {
    //     field: 'proposalSubmissionDeadline',
    //     message: 'Please Enter Submissipn Deadline',
    //   },
    //   {
    //     field: 'proposalValidityPeriodMax',
    //     message: 'Please Enter Validity Period',
    //   },
    //   {
    //     field: 'contractPeriodTermEnd',
    //     message: 'Please Enter Date',
    //     condition: () => parseInt(form.contractType, 10) === 1,
    //   },

    //   {
    //     field: 'descriptionOfPaymentTerms',
    //     message: 'Please Describe for Description of Payment Term',
    //   },
    //   {
    //     field: 'otherTermsAndCondition',
    //     message: 'Please Describe for Other Terms & Condition',
    //   },
    // ];

    const requiredFields = [
      {
        field: 'contractType',
        message: 'Please select a contract type',
      },
      {
        field: 'productTypeId',
        message: 'Please select a product type',
      },
      {
        field: 'productNameId',
        message: 'Please select a product name',
      },
      {
        field: 'productSpecification',
        message: 'Please provide the product specifications',
      },
      {
        field: 'contractPeriodTermStart',
        message: 'Please select the contract start date',
      },
      {
        field: 'proposalSubmissionDeadline',
        message: 'Please specify the proposal submission deadline',
      },
      {
        field: 'proposalValidityPeriodMax',
        message: 'Please specify the proposal validity period',
      },
      {
        field: 'contractPeriodTermEnd',
        message: 'Please select the contract end date',
        condition: () => parseInt(form.contractType, 10) === 1,
      },
      {
        field: 'descriptionOfDelayPenaltyTerms',
        message: 'Please provide the delay penalty terms description',
      },
      {
        field: 'descriptionOfPaymentTerms',
        message: 'Please provide the payment terms description',
      },
      {
        field: 'otherTermsAndCondition',
        message: 'Please provide other terms and conditions',
      },
    ];

    requiredFields.forEach(({ field, message, condition }) => {
      const value = form[field];

      // Jika ada kondisi tambahan, cek dulu
      if (condition && !condition()) return;

      // Validasi kosong atau hanya <br>
      if (!value || value === '<br>') {
        tempErrors[field] = message;
      }
    });

    // Validate clause descriptions
    if (dataCause?.items) {
      dataCause.items.forEach(item => {
        const clauseEdit = dataCause.procurementClauseDetails?.find(
          d => String(d.id) === String(item.id)
        );
        // inactive clauses are hidden from suppliers, so they need no wording
        if ((clauseEdit?.isActive ?? item.isActive) === false) return;
        const desc =
          clauseEdit?.clauseDescription ?? item.clauseDescription ?? '';

        if (!desc || desc === '<br>') {
          tempErrors[item.id] = `Please Describe for ${item.clauseTitle}`;
        }
      });
    }

    Object.assign(tempErrors, compositionRangeErrors(form));

    if (Object.keys(tempErrors).length > 0) {
      // Each item jumps to its field; the first one is focused automatically
      // by RequirementTab once the cards holding the errors are open.
      notify.warning(
        <div>
          Please correct the following fields (click one to go to it):
          <ul className='mb-0 mt-1' style={{ paddingLeft: '1.25rem' }}>
            {Object.entries(tempErrors).map(([key, msg]) => (
              <li key={key}>
                <button
                  type='button'
                  className='btn btn-link p-0 text-start align-baseline'
                  style={{ fontSize: 'inherit' }}
                  onClick={() => focusFieldById(requirementFieldId(key))}
                >
                  {msg}
                </button>
              </li>
            ))}
          </ul>
        </div>,
        { style: { width: '480px' } }
      );
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  document.title = `Procurement Requirement - ${form.procurementNumber}`;

  const categoryLabel = form.procurementTypeHeaderLabel || 'Product Hydro';
  const procurementTypeLabel = PROCUREMENT_TYPE_LABELS[form.procurementType];

  const contractLabel = form.contractType
    ? parseInt(form.contractType, 10) === 1
      ? 'TERM'
      : 'SPOT'
    : null;
  const formatMonth = value =>
    value && dayjs(value).isValid() ? dayjs(value).format('MMM YYYY') : null;
  const contractPeriod =
    contractLabel === 'TERM'
      ? [
          formatMonth(form.contractPeriodTermStart),
          formatMonth(form.contractPeriodTermEnd),
        ]
          .filter(Boolean)
          .join(' – ')
      : formatMonth(form.contractPeriodTermStart);
  const productLabel = [form.productName, productTypeNames(form)]
    .filter(Boolean)
    .join(' · ');
  const deadline =
    form.proposalSubmissionDeadline &&
    dayjs(form.proposalSubmissionDeadline).isValid()
      ? `${dayjs(form.proposalSubmissionDeadline).format('DD MMM YYYY, HH:mm')} WIB`
      : null;
  const supplierCount = (form.procurementMitra || []).length;

  const heroFacts = [
    {
      label: 'Contract',
      value: contractLabel
        ? [contractLabel, contractPeriod].filter(Boolean).join(' · ')
        : 'Not set yet',
      warn: !contractLabel,
    },
    {
      label: 'Product',
      value: productLabel || 'Not set yet',
      warn: !productLabel,
    },
    {
      label: 'Submission deadline',
      value: deadline || 'Not set yet',
      warn: !deadline,
    },
    {
      label: 'Suppliers selected',
      value: supplierCount > 0 ? supplierCount : 'None yet',
    },
  ];

  const nextTab = firstOpenStep ? firstOpenStep.tab : 5;
  const heroCta =
    isSubmitted || activeTab === nextTab
      ? null
      : {
          label: firstOpenStep
            ? `Continue: ${firstOpenStep.label}`
            : 'Review & submit',
          onClick: () => toggleTab(nextTab),
        };

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1 '>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <Row className='mt-n2 mb-1 mb-sm-0'>
                  <div className='col-sm order-3 order-sm-2'>
                    <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                      <h5 className='card-title mb-0 flex-grow-1'>
                        <PageBreadcrumb
                          fallback={{
                            label: 'Plan & Procurement',
                            to: '/apps-procurement/view',
                          }}
                          current={`Detail # ${displayValue(form?.procurementNumber || ids)}`}
                          listClassName='p-3 py-2 bg-light'
                        />
                      </h5>
                    </div>
                  </div>
                </Row>

                <ProcurementHero
                  loading={isLoading && !form?.procurementNumber}
                  title={`${categoryLabel} — ${displayValue(form?.titleProcurement)}`}
                  stage={stage}
                  badges={
                    procurementTypeLabel && (
                      <span className='pd-pill'>{procurementTypeLabel}</span>
                    )
                  }
                  meta={
                    <>
                      <span>
                        <i className='ri-hashtag' aria-hidden='true'></i>
                        {displayValue(form?.procurementNumber)}
                      </span>
                      <span>
                        <i className='ri-calendar-line' aria-hidden='true'></i>
                        Created {formatSubmittedDate(form?.createdDate)}
                      </span>
                    </>
                  }
                  facts={heroFacts}
                  progress={{ done: doneCount, total: stepperSteps.length }}
                  cta={heroCta}
                  onBack={() => navigate('/apps-procurement/view')}
                />

                {isSubmitted && (
                  <div className='pd-lockbar' role='status'>
                    <i className='ri-lock-line' aria-hidden='true'></i>
                    <span>
                      <strong>Submitted for final validation.</strong> This
                      procurement is read-only.
                    </span>
                  </div>
                )}

                <ProcurementStepper
                  steps={stepperSteps}
                  activeTab={activeTab}
                  onSelect={toggleTab}
                />

                <Row className='justify-content-center mb-4'>
                  <Col xxl={12}>
                    <TabContent activeTab={activeTab}>
                      {Object.entries(TAB_COMPONENTS).map(
                        ([tabKey, TabComponent]) => {
                          const tabId = Number(tabKey);
                          const tabProps = (() => {
                            switch (tabId) {
                              case 1:
                                return {
                                  goNext: () => toggleTab(2),
                                  ids,
                                  form,
                                  setForm,
                                  dataCause,
                                  setDataCause,
                                  handleSaveDraftProc,
                                  handleSaveCompleteProc,
                                  validatedeliveryModal,
                                  errors,
                                  setErrors,
                                  setIsLoading,
                                  isLoading,
                                  completedMode,
                                  onRefreshForm: silentRefresh,
                                };
                              case 2:
                                return {
                                  goNext: () => toggleTab(4),
                                  goBack: () => toggleTab(1),
                                  ids,
                                  form,
                                  setForm,
                                  handleSaveCompleteDoc,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                };
                              case 3:
                                return {
                                  goNext: () => toggleTab(5),
                                  goBack: () => toggleTab(4),
                                  ids,
                                  form,
                                  setForm,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                  handleSaveDraftProc,
                                  handleSaveCompleteDmut,
                                };
                              case 4:
                                return {
                                  goNext: () => toggleTab(3),
                                  goBack: () => toggleTab(2),
                                  form,
                                  setForm,
                                  handleSaveProc,
                                  handleSaveCompleteGtc,
                                };
                              case 5:
                                return {
                                  goBack: () => toggleTab(3),
                                  goToStep: toggleTab,
                                  ids,
                                  form,
                                  setForm,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                  errors,
                                  setErrors,
                                };
                              default:
                                return {};
                            }
                          })();

                          return (
                            <TabPane
                              key={tabId}
                              tabId={tabId}
                              {...(tabId === 1
                                ? { id: 'pills-bill-info' }
                                : {})}
                              {...(tabId === 5 ? { id: 'pills-finish' } : {})}
                            >
                              <TabComponent {...tabProps} />
                            </TabPane>
                          );
                        }
                      )}
                    </TabContent>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProcurementForm;
